import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import {
  AnalyticsOverviewResponse,
  AnalyticsSection,
} from '../../../../types/adminAnalytics.ts';
import {
  overviewToChartData,
  getOverviewChartHeight,
} from '../../../../utils/analyticsChartData.ts';
import AnalyticsChartTooltip from './AnalyticsChartTooltip.tsx';
import styles from './AnalyticsCharts.module.scss';

const ACTUAL_COLOR = '#234ba2';
const PREVIOUS_COLOR = '#94a3b8';

interface AnalyticsOverviewBarChartProps {
  overview: AnalyticsOverviewResponse;
  sectionKeys: AnalyticsSection[];
}

const AnalyticsOverviewBarChart: React.FC<AnalyticsOverviewBarChartProps> = ({
  overview,
  sectionKeys,
}) => {
  const data = overviewToChartData(overview, sectionKeys);
  if (!data.length) return null;

  const height = getOverviewChartHeight(data.length);

  return (
    <div
      className={styles.chartCard}
      data-analytics-export-chart="overview"
    >
      <h4 className={styles.chartTitle}>Resumen por área (suma de métricas)</h4>
      <div className={styles.chartBody} style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 8, right: 16, left: 8, bottom: 48 }}
            isAnimationActive={false}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e8edf3" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 11 }}
              interval={0}
              angle={-25}
              textAnchor="end"
              height={70}
            />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip content={<AnalyticsChartTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="actual" name="Período actual" fill={ACTUAL_COLOR} radius={[4, 4, 0, 0]} />
            <Bar dataKey="anterior" name="Período anterior" fill={PREVIOUS_COLOR} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AnalyticsOverviewBarChart;
